/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.com.mu.city.api.CityInfo', null, global);
goog.exportSymbol('proto.com.mu.city.api.CountryItem', null, global);
goog.exportSymbol('proto.com.mu.city.api.GetCitiesByCountryRequest', null, global);
goog.exportSymbol('proto.com.mu.city.api.GetCitiesByCountryResponse', null, global);
goog.exportSymbol('proto.com.mu.city.api.GetCountriesRequest', null, global);
goog.exportSymbol('proto.com.mu.city.api.GetCountriesResponse', null, global);
goog.exportSymbol('proto.com.mu.city.api.StatusInfo', null, global);
goog.exportSymbol('proto.com.mu.city.api.StatusInfo.ErrorCode', null, global);
goog.exportSymbol('proto.com.mu.city.api.StatusInfo.StatusType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.city.api.GetCitiesByCountryRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.city.api.GetCitiesByCountryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.city.api.GetCitiesByCountryRequest.displayName = 'proto.com.mu.city.api.GetCitiesByCountryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.city.api.GetCitiesByCountryResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.city.api.GetCitiesByCountryResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.city.api.GetCitiesByCountryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.city.api.GetCitiesByCountryResponse.displayName = 'proto.com.mu.city.api.GetCitiesByCountryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.city.api.CityInfo = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.city.api.CityInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.city.api.CityInfo.displayName = 'proto.com.mu.city.api.CityInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.city.api.GetCountriesRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.city.api.GetCountriesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.city.api.GetCountriesRequest.displayName = 'proto.com.mu.city.api.GetCountriesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.city.api.GetCountriesResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.city.api.GetCountriesResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.city.api.GetCountriesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.city.api.GetCountriesResponse.displayName = 'proto.com.mu.city.api.GetCountriesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.city.api.CountryItem = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.city.api.CountryItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.city.api.CountryItem.displayName = 'proto.com.mu.city.api.CountryItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.city.api.StatusInfo = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.city.api.StatusInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.city.api.StatusInfo.displayName = 'proto.com.mu.city.api.StatusInfo';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.city.api.GetCitiesByCountryRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.city.api.GetCitiesByCountryRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.city.api.GetCitiesByCountryRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.city.api.GetCitiesByCountryRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        countryid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        status: jspb.Message.getFieldWithDefault(msg, 2, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.city.api.GetCitiesByCountryRequest}
 */
proto.com.mu.city.api.GetCitiesByCountryRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.city.api.GetCitiesByCountryRequest();
  return proto.com.mu.city.api.GetCitiesByCountryRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.city.api.GetCitiesByCountryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.city.api.GetCitiesByCountryRequest}
 */
proto.com.mu.city.api.GetCitiesByCountryRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setCountryid(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatus(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.city.api.GetCitiesByCountryRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.city.api.GetCitiesByCountryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.city.api.GetCitiesByCountryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.city.api.GetCitiesByCountryRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCountryid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
};

/**
 * optional int32 countryId = 1;
 * @return {number}
 */
proto.com.mu.city.api.GetCitiesByCountryRequest.prototype.getCountryid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.city.api.GetCitiesByCountryRequest.prototype.setCountryid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string status = 2;
 * @return {string}
 */
proto.com.mu.city.api.GetCitiesByCountryRequest.prototype.getStatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.city.api.GetCitiesByCountryRequest.prototype.setStatus = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.city.api.GetCitiesByCountryResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.city.api.GetCitiesByCountryResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.city.api.GetCitiesByCountryResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.city.api.GetCitiesByCountryResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.city.api.GetCitiesByCountryResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        citiesList: jspb.Message.toObjectList(msg.getCitiesList(), proto.com.mu.city.api.CityInfo.toObject, includeInstance),
        status: (f = msg.getStatus()) && proto.com.mu.city.api.StatusInfo.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.city.api.GetCitiesByCountryResponse}
 */
proto.com.mu.city.api.GetCitiesByCountryResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.city.api.GetCitiesByCountryResponse();
  return proto.com.mu.city.api.GetCitiesByCountryResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.city.api.GetCitiesByCountryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.city.api.GetCitiesByCountryResponse}
 */
proto.com.mu.city.api.GetCitiesByCountryResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.mu.city.api.CityInfo();
        reader.readMessage(value, proto.com.mu.city.api.CityInfo.deserializeBinaryFromReader);
        msg.addCities(value);
        break;
      case 2:
        var value = new proto.com.mu.city.api.StatusInfo();
        reader.readMessage(value, proto.com.mu.city.api.StatusInfo.deserializeBinaryFromReader);
        msg.setStatus(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.city.api.GetCitiesByCountryResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.city.api.GetCitiesByCountryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.city.api.GetCitiesByCountryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.city.api.GetCitiesByCountryResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.com.mu.city.api.CityInfo.serializeBinaryToWriter);
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(2, f, proto.com.mu.city.api.StatusInfo.serializeBinaryToWriter);
  }
};

/**
 * repeated CityInfo cities = 1;
 * @return {!Array<!proto.com.mu.city.api.CityInfo>}
 */
proto.com.mu.city.api.GetCitiesByCountryResponse.prototype.getCitiesList = function () {
  return /** @type{!Array<!proto.com.mu.city.api.CityInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.city.api.CityInfo, 1)
  );
};

/** @param {!Array<!proto.com.mu.city.api.CityInfo>} value */
proto.com.mu.city.api.GetCitiesByCountryResponse.prototype.setCitiesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};

/**
 * @param {!proto.com.mu.city.api.CityInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.city.api.CityInfo}
 */
proto.com.mu.city.api.GetCitiesByCountryResponse.prototype.addCities = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.city.api.CityInfo, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.city.api.GetCitiesByCountryResponse.prototype.clearCitiesList = function () {
  this.setCitiesList([]);
};

/**
 * optional StatusInfo status = 2;
 * @return {?proto.com.mu.city.api.StatusInfo}
 */
proto.com.mu.city.api.GetCitiesByCountryResponse.prototype.getStatus = function () {
  return /** @type{?proto.com.mu.city.api.StatusInfo} */ (jspb.Message.getWrapperField(this, proto.com.mu.city.api.StatusInfo, 2));
};

/** @param {?proto.com.mu.city.api.StatusInfo|undefined} value */
proto.com.mu.city.api.GetCitiesByCountryResponse.prototype.setStatus = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.city.api.GetCitiesByCountryResponse.prototype.clearStatus = function () {
  this.setStatus(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.city.api.GetCitiesByCountryResponse.prototype.hasStatus = function () {
  return jspb.Message.getField(this, 2) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.city.api.CityInfo.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.city.api.CityInfo.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.city.api.CityInfo} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.city.api.CityInfo.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        cityid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        cityname: jspb.Message.getFieldWithDefault(msg, 2, ''),
        countryid: jspb.Message.getFieldWithDefault(msg, 3, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.city.api.CityInfo}
 */
proto.com.mu.city.api.CityInfo.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.city.api.CityInfo();
  return proto.com.mu.city.api.CityInfo.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.city.api.CityInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.city.api.CityInfo}
 */
proto.com.mu.city.api.CityInfo.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setCityid(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setCityname(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setCountryid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.city.api.CityInfo.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.city.api.CityInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.city.api.CityInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.city.api.CityInfo.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCityid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getCityname();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getCountryid();
  if (f !== 0) {
    writer.writeInt32(3, f);
  }
};

/**
 * optional int32 cityId = 1;
 * @return {number}
 */
proto.com.mu.city.api.CityInfo.prototype.getCityid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.city.api.CityInfo.prototype.setCityid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string cityName = 2;
 * @return {string}
 */
proto.com.mu.city.api.CityInfo.prototype.getCityname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.city.api.CityInfo.prototype.setCityname = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional int32 countryId = 3;
 * @return {number}
 */
proto.com.mu.city.api.CityInfo.prototype.getCountryid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/** @param {number} value */
proto.com.mu.city.api.CityInfo.prototype.setCountryid = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.city.api.GetCountriesRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.city.api.GetCountriesRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.city.api.GetCountriesRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.city.api.GetCountriesRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.city.api.GetCountriesRequest}
 */
proto.com.mu.city.api.GetCountriesRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.city.api.GetCountriesRequest();
  return proto.com.mu.city.api.GetCountriesRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.city.api.GetCountriesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.city.api.GetCountriesRequest}
 */
proto.com.mu.city.api.GetCountriesRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.city.api.GetCountriesRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.city.api.GetCountriesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.city.api.GetCountriesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.city.api.GetCountriesRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.city.api.GetCountriesResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.city.api.GetCountriesResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.city.api.GetCountriesResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.city.api.GetCountriesResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.city.api.GetCountriesResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        countriesList: jspb.Message.toObjectList(msg.getCountriesList(), proto.com.mu.city.api.CountryItem.toObject, includeInstance),
        status: (f = msg.getStatus()) && proto.com.mu.city.api.StatusInfo.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.city.api.GetCountriesResponse}
 */
proto.com.mu.city.api.GetCountriesResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.city.api.GetCountriesResponse();
  return proto.com.mu.city.api.GetCountriesResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.city.api.GetCountriesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.city.api.GetCountriesResponse}
 */
proto.com.mu.city.api.GetCountriesResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.mu.city.api.CountryItem();
        reader.readMessage(value, proto.com.mu.city.api.CountryItem.deserializeBinaryFromReader);
        msg.addCountries(value);
        break;
      case 2:
        var value = new proto.com.mu.city.api.StatusInfo();
        reader.readMessage(value, proto.com.mu.city.api.StatusInfo.deserializeBinaryFromReader);
        msg.setStatus(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.city.api.GetCountriesResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.city.api.GetCountriesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.city.api.GetCountriesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.city.api.GetCountriesResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCountriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.com.mu.city.api.CountryItem.serializeBinaryToWriter);
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(2, f, proto.com.mu.city.api.StatusInfo.serializeBinaryToWriter);
  }
};

/**
 * repeated CountryItem countries = 1;
 * @return {!Array<!proto.com.mu.city.api.CountryItem>}
 */
proto.com.mu.city.api.GetCountriesResponse.prototype.getCountriesList = function () {
  return /** @type{!Array<!proto.com.mu.city.api.CountryItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.city.api.CountryItem, 1)
  );
};

/** @param {!Array<!proto.com.mu.city.api.CountryItem>} value */
proto.com.mu.city.api.GetCountriesResponse.prototype.setCountriesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};

/**
 * @param {!proto.com.mu.city.api.CountryItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.city.api.CountryItem}
 */
proto.com.mu.city.api.GetCountriesResponse.prototype.addCountries = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.city.api.CountryItem, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.city.api.GetCountriesResponse.prototype.clearCountriesList = function () {
  this.setCountriesList([]);
};

/**
 * optional StatusInfo status = 2;
 * @return {?proto.com.mu.city.api.StatusInfo}
 */
proto.com.mu.city.api.GetCountriesResponse.prototype.getStatus = function () {
  return /** @type{?proto.com.mu.city.api.StatusInfo} */ (jspb.Message.getWrapperField(this, proto.com.mu.city.api.StatusInfo, 2));
};

/** @param {?proto.com.mu.city.api.StatusInfo|undefined} value */
proto.com.mu.city.api.GetCountriesResponse.prototype.setStatus = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.city.api.GetCountriesResponse.prototype.clearStatus = function () {
  this.setStatus(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.city.api.GetCountriesResponse.prototype.hasStatus = function () {
  return jspb.Message.getField(this, 2) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.city.api.CountryItem.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.city.api.CountryItem.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.city.api.CountryItem} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.city.api.CountryItem.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        id: jspb.Message.getFieldWithDefault(msg, 1, 0),
        iso: jspb.Message.getFieldWithDefault(msg, 2, ''),
        name: jspb.Message.getFieldWithDefault(msg, 3, ''),
        active: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
        indicative: jspb.Message.getFieldWithDefault(msg, 5, ''),
        currency: jspb.Message.getFieldWithDefault(msg, 6, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.city.api.CountryItem}
 */
proto.com.mu.city.api.CountryItem.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.city.api.CountryItem();
  return proto.com.mu.city.api.CountryItem.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.city.api.CountryItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.city.api.CountryItem}
 */
proto.com.mu.city.api.CountryItem.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setId(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setIso(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setName(value);
        break;
      case 4:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setActive(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setIndicative(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setCurrency(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.city.api.CountryItem.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.city.api.CountryItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.city.api.CountryItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.city.api.CountryItem.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getIso();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(4, f);
  }
  f = message.getIndicative();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
};

/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.com.mu.city.api.CountryItem.prototype.getId = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.city.api.CountryItem.prototype.setId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string iso = 2;
 * @return {string}
 */
proto.com.mu.city.api.CountryItem.prototype.getIso = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.city.api.CountryItem.prototype.setIso = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string name = 3;
 * @return {string}
 */
proto.com.mu.city.api.CountryItem.prototype.getName = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.city.api.CountryItem.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional bool active = 4;
 * @return {boolean}
 */
proto.com.mu.city.api.CountryItem.prototype.getActive = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};

/** @param {boolean} value */
proto.com.mu.city.api.CountryItem.prototype.setActive = function (value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};

/**
 * optional string indicative = 5;
 * @return {string}
 */
proto.com.mu.city.api.CountryItem.prototype.getIndicative = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.city.api.CountryItem.prototype.setIndicative = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string currency = 6;
 * @return {string}
 */
proto.com.mu.city.api.CountryItem.prototype.getCurrency = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.city.api.CountryItem.prototype.setCurrency = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.city.api.StatusInfo.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.city.api.StatusInfo.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.city.api.StatusInfo} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.city.api.StatusInfo.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        status: jspb.Message.getFieldWithDefault(msg, 1, 0),
        errorcode: jspb.Message.getFieldWithDefault(msg, 2, 0),
        message: jspb.Message.getFieldWithDefault(msg, 3, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.city.api.StatusInfo}
 */
proto.com.mu.city.api.StatusInfo.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.city.api.StatusInfo();
  return proto.com.mu.city.api.StatusInfo.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.city.api.StatusInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.city.api.StatusInfo}
 */
proto.com.mu.city.api.StatusInfo.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {!proto.com.mu.city.api.StatusInfo.StatusType} */ (reader.readEnum());
        msg.setStatus(value);
        break;
      case 2:
        var value = /** @type {!proto.com.mu.city.api.StatusInfo.ErrorCode} */ (reader.readEnum());
        msg.setErrorcode(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setMessage(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.city.api.StatusInfo.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.city.api.StatusInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.city.api.StatusInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.city.api.StatusInfo.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(1, f);
  }
  f = message.getErrorcode();
  if (f !== 0.0) {
    writer.writeEnum(2, f);
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
};

/**
 * @enum {number}
 */
proto.com.mu.city.api.StatusInfo.StatusType = {
  SUCCESS: 0,
  ERROR: 1,
};

/**
 * @enum {number}
 */
proto.com.mu.city.api.StatusInfo.ErrorCode = {
  OK: 0,
  GENERAL_ERROR: 1,
  NOT_FOUND: 2,
};

/**
 * optional StatusType status = 1;
 * @return {!proto.com.mu.city.api.StatusInfo.StatusType}
 */
proto.com.mu.city.api.StatusInfo.prototype.getStatus = function () {
  return /** @type {!proto.com.mu.city.api.StatusInfo.StatusType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {!proto.com.mu.city.api.StatusInfo.StatusType} value */
proto.com.mu.city.api.StatusInfo.prototype.setStatus = function (value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};

/**
 * optional ErrorCode errorCode = 2;
 * @return {!proto.com.mu.city.api.StatusInfo.ErrorCode}
 */
proto.com.mu.city.api.StatusInfo.prototype.getErrorcode = function () {
  return /** @type {!proto.com.mu.city.api.StatusInfo.ErrorCode} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {!proto.com.mu.city.api.StatusInfo.ErrorCode} value */
proto.com.mu.city.api.StatusInfo.prototype.setErrorcode = function (value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};

/**
 * optional string message = 3;
 * @return {string}
 */
proto.com.mu.city.api.StatusInfo.prototype.getMessage = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.city.api.StatusInfo.prototype.setMessage = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

goog.object.extend(exports, proto.com.mu.city.api);
